if(!customElements.get('cart-tracker')){
    class CartTracker extends HTMLElement {
        constructor() {
            super();
            theme?.Cart ? theme.Cart.Tracker = this : theme.Cart = {Tracker: this}
            this.WrapNumber = ParseBoolean(this.dataset.wrapNumber) === false ? false : true 
        }

        cartUpdateUnsubscriber = undefined;
        
        connectedCallback() {
            this.cartUpdateUnsubscriber = SubscribeToEvent('UpdateCart', (eventData) => {
                this.onCartUpdated(eventData);
            });
        }

        disconnectedCallback() {
            if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
            }
        }

        onCartUpdated(eventData) {
            console.log('data:', eventData)
            if (eventData.item_count >=0) {
                this.setAttribute('data-count', eventData.item_count)
                if (eventData.item_count > 0) {
                    if(this.WrapNumber){
                        this.innerHTML = `(${eventData.item_count})`
                    } else {
                        this.innerHTML = `${eventData.item_count}`
                    }
                } else {
                    this.innerHTML = ''
                }

            }
        }
    }
    customElements.define('cart-tracker', CartTracker);
}